import _ from "lodash";
import moment from "moment";
import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { change as changeFieldValue } from "redux-form";
import * as dataActions from "../../../../../../utils/data/dataActions";
import * as types from "../../../../../../utils/data/dataActionTypes";
import { MEMBERS } from "../../../../../../utils/data/models";
import {
    ADMINISTRATOR,
    AGENT,
    HR_CLERK,
    DIRECTOR,
    FINTECH,
    HIGH_MANAGEMENT_WITH_FINANCE,
    MANAGER,
    PLAN_ADMINISTRATOR,
} from "../../../../../../utils/Roles";
import userHasAccess from "../../../../../../utils/userHasAccess";
import { ACTIVE, IMPLEMENTATION, INACTIVE, TERMINATED } from "../../../enums/clientStatusTypes";
import { MemberProfileForm } from "./";
import { getLatestMemberSyncs } from "../../../../../common/synchronization/SynchronizationHelper";
import { isEmptyString } from "../../../../../common/Helpers/StringHelper";
import { tryParseBoolean } from "../../../../../common/Helpers/BooleanHelper";

class MemberProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isExistingMemberIdentifier: false,
        };

        this.getCanModifyOrCreateForClientStatusType = this.getCanModifyOrCreateForClientStatusType.bind(this);
        this.handleSubmit = _.debounce(this.handleSubmit.bind(this), 350);
        this.memberEditableForImplementation = userHasAccess(HIGH_MANAGEMENT_WITH_FINANCE, true);
        this.memberEditableForActive = userHasAccess(
            [DIRECTOR, MANAGER, AGENT, PLAN_ADMINISTRATOR, ADMINISTRATOR, FINTECH, HR_CLERK],
            true
        );
        this.memberEditableForTerminated = userHasAccess(FINTECH);
    }

    componentWillUpdate(nextProps) {
        const { member, changeFieldValue } = this.props;

        if (member && nextProps.member && !_.isEqual(member, nextProps.member)) {
            changeFieldValue("memberForm", "customEmailAddress", nextProps.member.customEmailAddress);
            changeFieldValue("memberForm", "customInformation", nextProps.member.customInformation);
            changeFieldValue("memberForm", "customPhoneNumber", nextProps.member.customPhoneNumber);
        }
    }

    getCanModifyOrCreateForClientStatusType(clientStatusType) {
        const { member } = this.props;

        const isMemberArchived = member && member.isArchived && !userHasAccess(FINTECH);
        switch (clientStatusType) {
            case IMPLEMENTATION.value:
                return this.memberEditableForImplementation && !isMemberArchived;
            case ACTIVE.value:
            case INACTIVE.value:
                return this.memberEditableForActive && !isMemberArchived;
            case TERMINATED.value:
                return this.memberEditableForTerminated && !isMemberArchived;
        }
    }

    handleSubmit(values) {
        let dataToUpdate = values;
        Object.entries(dataToUpdate).forEach(([key, value]) => {
            switch (key) {
                case "provinceCode":
                    if (value === "noProvinces" || isEmptyString(value)) dataToUpdate[key] = null;
                    break;
                case "isInternational":
                    if (isEmptyString(value)) dataToUpdate[key] = null;
                    dataToUpdate[key] = tryParseBoolean(value);
                    break;
                case "memberPayFrequencyType":
                    if (isEmptyString(value)) dataToUpdate[key] = null;
                    break;
                case "isCanadian":
                    if (isEmptyString(value)) dataToUpdate[key] = null;
                    else if (tryParseBoolean(value) !== false) dataToUpdate["provincialHealthNumber"] = null;
                    dataToUpdate[key] = tryParseBoolean(value);
                    break;
                case "provincialHealthNumber":
                    if (value) dataToUpdate["isCanadian"] = false;
                    break;
                case "weeklyHours":
                    if (isEmptyString(value)) dataToUpdate[key] = null;
                    break;
                case "isSmoker":
                    if (isEmptyString(value)) dataToUpdate[key] = null;
                    dataToUpdate[key] = tryParseBoolean(value);
                    break;
                case "quarter":
                    if (isEmptyString(value)) dataToUpdate[key] = null;
                    break;
                case "birthdate":
                    if (isEmptyString(value)) dataToUpdate[key] = null;
                    break;
                case "memberIdentifierRecoveryDate":
                    if (isEmptyString(value)) dataToUpdate[key] = null;
                    break;
            }
            if (typeof dataToUpdate[key] === "string" && dataToUpdate[key] !== null) {
                dataToUpdate[key] = dataToUpdate[key].trim();
            }
        });
        delete dataToUpdate.memberPartnerHash;
        this.props.dataActions.updateDataItem(MEMBERS, dataToUpdate).then((data) => {
            if (data.type === types.UPDATE_DATA_ITEM_FAILURE) {
                if (data.payload.error.data.error === "invalidDataType") {
                    toast(<FormattedMessage id="members.member.errors.invalidDataType" />, {
                        type: toast.TYPE.ERROR,
                    });
                } else if (data.payload.error.data.error === "duplicateMemberIdentifier") {
                    this.setState({ isExistingMemberIdentifier: true });
                }
                else if (data.payload.error.data.error === "noAlphabetsInMemberIdentifier") {
                    toast(
                        <FormattedMessage id="members.form.invalidUniqueNumberAlphabet" />, {
                        type: toast.TYPE.ERROR
                    });
                }
                else {
                    toast(<FormattedMessage id="genericSaveError" />, {
                        type: toast.TYPE.ERROR,
                    });
                }
            } else {
                const { member } = this.props;
                this.setState({ isExistingMemberIdentifier: false });
                this.props.dataActions.getDataItem(MEMBERS, this.props.member.memberId, {
                    fields: "beneficiaries(isArchived),memberCoverages(memberCoverageGuarantees(*),*),*",
                });
                getLatestMemberSyncs(member.clientId, [member.memberId], this.props.dataActions);
                toast(<FormattedMessage id="genericSaveSuccess" />, {
                    type: toast.TYPE.SUCCESS,
                });
            }
        });
    }
    renderFormatedMessage(icon) {
        return <span className="icon warning">{icon}</span>;
    }
    render() {
        const { member, client, changeFieldValue, roleId, fetchingMember } = this.props;
        const defaultCountry = !!member && !!member.importationDate ? null : "CA";
        let profile = { ...member };

        let isAllowed = false;
        if (client && client.hasOwnProperty("clientStatusType")) {
            isAllowed = this.getCanModifyOrCreateForClientStatusType(client.clientStatusType);
            if (profile.isEditable) {
                /**
                 * Only override isEditable with role management rules, if value in db is true.
                 */
                profile.isEditable = isAllowed;
            }
        }
        return (
            <div>
                {!!member && (
                    <div>
                        <MemberProfileForm
                            blockSubmit={fetchingMember}
                            isExistingMemberIdentifier={this.state.isExistingMemberIdentifier}
                            isArchived={this.props.isArchived}
                            member={profile}
                            isAllowed={isAllowed}
                            initialValues={{
                                ...member,
                                birthdate: member.birthdate ? moment(new Date(member.birthdate).toISOString()) : null,
                                countryCode: member.countryCode || defaultCountry,
                            }}
                            onSubmit={this.handleSubmit}
                            changeFieldValue={changeFieldValue}
                            roleId={roleId}
                        />
                    </div>
                )}
            </div>
        );
    }
}

MemberProfile.propTypes = {
    member: PropTypes.object,
    dataActions: PropTypes.object,
    client: PropTypes.object,
    isArchived: PropTypes.bool,
    changeFieldValue: PropTypes.func,
    roleId: PropTypes.number,
    fetchingMember: PropTypes.bool
};

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    };
}

function mapStateToProps(state) {
    const clients = state.data.clients;
    return {
        fetchingMember: state.data.members.fetching,
        member: state.data.members && state.data.members.active,
        client: clients && clients.active ? clients.active : null,
        isArchived: clients && clients.active ? clients.active.isArchived : null,
        roleId: state.auth.user.roleId,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MemberProfile);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/MemberProfile.js